<template>
    <div id="content" class="w">
        <div class="lg_box">
            <img src="../../assets/picture/login_bg.jpg" width="410" height="490" class="lf_bg">
            <img src="../../assets/image/login_rma.png" width="80" height="80" class="lf_rm" id="lf_rm" @mouseleave="onMouseOut($event)" @mouseenter="onMouseOver($event)">
            <img src="../../assets/image/minapp_qw.jpg" width="200" height="228" class="lf_rmb hid" id="lf_rmb" :style="active">
            <div id="logbox" v-show="showLogin">
                <h1 class="lh1 yahei" id="lh1">账号密码登录</h1>
                <p v-show="showTishi">{{tishi}}</p>
                <div id="login_name" class="logx">
                    <form action="" method="post">
                        <div class="llabel">
                            <em class="ll_left">帐号</em>
                            <input type="text" v-model="username" class="llpt" value="" maxlength="13" placeholder="请输入手机号">
                        </div>
                        <div class="llabel">
                            <em class="ll_left">密码</em>
                            <input type="password" v-model="password" class="llpt" value="" placeholder="请输入密码" maxlength="6">
                        </div>
                        <p @click="login_name" class="log_btn yahei">登录</p>
                    </form>
                </div>
                <div id="login_name" class="logx" style="padding-top:0;">
                    <div class="alC">
                        <a href="javascript:;" class="ck_a">返回</a>
                        <a href="javascript:;" @click="ToRegister" class="ck_a">手机注册</a>
                        <a href="javascript:;" @click="ToLorgetPassword" class="ck_a">忘记密码</a>
                        <a href="javascript:;" class="ck_a">回首页</a>
                    </div>
                </div>
            </div>
            <div id="logbox" v-show="showRegister">
                <h1 class="lh1 yahei" id="lh1">注册账号</h1>
                <p v-show="showTishi">{{tishi}}</p>
                <div id="phone_login" class="logx">
                    <form action="" method="post">
                        <div class="llabel">
                            <em class="ll_left yahei">手机号:</em>
                            <input type="text" v-model="newUsername" class="llpt" value="" maxlength="11" placeholder="输入11位手机号">
                        </div>
                        <div class="llabel">
                            <em class="ll_left yahei">验证码:</em>
                            <input type="number" v-model="code" class="llpt" value="" maxlength="6" placeholder="输入验证码">
                            <button @click.prevent="getCODE" class="dxm" :disabled="!show">
                                <span v-show="show">获取短信验证码</span>
                                <span v-show="!show" class="count">{{count}} s</span>
                            </button>
                        </div>
                        <div class="llabel">
                            <em class="ll_left yahei">昵称:</em>
                            <input type="text" v-model="nickname" class="llpt" value="" maxlength="20" placeholder="请输入用户昵称">
                        </div>
                        <div class="llabel">
                            <em class="ll_left yahei">密码:</em>
                            <input type="password" v-model="newPassword" class="llpt" value="" maxlength="6" placeholder="密码长度6位，且同时包含字母和数字">
                        </div>
                        <div class="llabel">
                            <em class="ll_left yahei">邀请码:</em>
                            <input type="text" v-model="share" id="share" class="llpt" value="" maxlength="20" placeholder="请输入邀请码，获得更多优惠">
                        </div>
                        <p @click="register" class="log_btn yahei" id="log_btn">注册</p>
                    </form>
                </div>
                <div id="phone_login" class="logx" style="padding-top:0;">
                    <div class="alC">
                        <a href="javascript:;" class="ck_a">返回</a>
                        <a href="javascript:;" @click="ToLogin" class="ck_a">帐号密码登录</a>
                        <a href="javascript:;" @click="ToLorgetPassword" class="ck_a">忘记密码</a>
                        <a href="javascript:;" class="ck_a">回首页</a>
                    </div>
                </div>
            </div>
            <div id="logbox" v-show="forgetPassword">
                <h1 class="lh1 yahei" id="lh1">重置密码</h1>
                <p v-show="showTishi">{{tishi}}</p>
                <div id="phone_login" class="logx">
                    <form action="" method="post">
                        <div class="llabel">
                            <em class="ll_left yahei">手机号:</em>
                            <input type="text" v-model="newUsername" class="llpt" value="" maxlength="11" placeholder="输入11位手机号">
                        </div>
                        <div class="llabel">
                            <em class="ll_left yahei">验证码:</em>
                            <input type="number" v-model="code" class="llpt" value="" maxlength="6" placeholder="输入验证码">
                            <button @click.prevent="getForgetPasswordCODE" class="dxm" :disabled="!show">
                                <span v-show="show">获取短信验证码</span>
                                <span v-show="!show" class="count">{{count}} s</span>
                            </button>
                        </div>
                        <div class="llabel">
                            <em class="ll_left yahei">密码:</em>
                            <input type="password" v-model="newPassword" class="llpt" value="" maxlength="6" placeholder="密码长度6位，且同时包含字母和数字">
                        </div>
                        <p @click="forgetPasswordReset" class="log_btn yahei" id="log_btn">立即重置</p>
                    </form>
                </div>
                <div id="phone_login" class="logx" style="padding-top:0;">
                    <div class="alC">
                        <a href="javascript:;" class="ck_a">返回</a>
                        <a href="javascript:;" @click="ToLogin" class="ck_a">帐号密码登录</a>
                        <a href="javascript:;" @click="ToLorgetPassword" class="ck_a">忘记密码</a>
                        <a href="javascript:;" class="ck_a">回首页</a>
                    </div>
                </div>
            </div>
            <p class="fuwu">
                登录代表同意夜樱情趣 
                <a href="javascript:;" class="U">服务协议</a>
                <a href="javascript:;" class="U">法律声明</a>
                <a href="javascript:;" class="U">隐私政策权</a>
            </p>
            <!-- <div class="hid" id="loginscuess" v-show="showHid">
                <div class="lgxx">
                    <img src="../../assets/picture/bigyes.png" width="60" height="60">
                    <h2 class="f16 yahei" style="color:#0ba816;margin-top:20px;" id="tishi">恭喜，登录成功!</h2>
                    <p id="miaod"><b id="tims">5</b>秒后自动返回到上一页</p>
                    <p>&nbsp;</p>
                    <div class="f0">
                        <a href="javascript:;" class="lg_btn">进入会员中心</a>
                        <a href="javascript:;" class="lg_btn lg_btnr">返回上一页</a>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
export default {
    props: {
        tshare: {
            type: String,
            default: "",
        },
        str: {
            type: String,
            default: "中国(+86)",
        },
        isgj: {
            type: String,
            default: "",
        },
        is_wallet_key: {
            type: [String, Number],
        },
        check: {
            type: Boolean,
            default: true,
        },
    },
    data(){
        return{
            show: 'false',
            count: '',
            active: "",
            showLogin: true,
            showRegister: false,
            forgetPassword: false,
            showTishi: false,
            showHid: false,
            tishi: '',
            username: '',
            password: '',
            newUsername: '',
            newPassword: '',
            nickname: "",
            code:"",
            gj: this.str,
            share: this.tshare,
            num: 60,
            data:{}
        }
    },
    computed: {
        ...mapState({
            storeUuid: (state) => state.appUuid,
        }),
        getConfig () {
            return this.$store.state.config;
        },
    },
    mounted(){
    },
    methods:{
        ToRegister(){
            this.showRegister = true
            this.showLogin = false
            this.forgetPassword = false
        },
        ToLogin(){
            this.showRegister = false
            this.showLogin = true
            this.forgetPassword = false
        },
        ToLorgetPassword(){
            this.showRegister = false
            this.showLogin = false
            this.forgetPassword = true
        },
        onMouseOver($event){
            this.active="display:inline"
        },
        onMouseOut($event){
            this.active="display:none"
        },
        login_name(){
            if(this.username == "" || this.password == ""){
                alert("请输入手机号码或密码")
            }else{
                // /*接口请求*/
                var params = {};
                params.username = this.username;
                params.password = this.$getCode(this.password);
                params.quhao = this.gj.replace(/[^0-9]/gi, "");
                this.$api.getLogin.getUserLogin(params).then((res)=>{
                    if(res.code == 200){
                        var val = res.result;
                        if (val.im) {
                            this.$store.dispatch("login", {
                                userID: val.im,
                                userSig: val.im_sig
                                
                            });
                        }
                        this.$store.commit("setUser", res.result);
                        this.tishi = "登录成功"
                        this.showTishi = true
                        this.showHid = true
                        var id = JSON.stringify(res.result);//将获取到的数据转换为json数据
                        var ses = window.localStorage; 
                        ses.setItem("user", id); //将id的内容存入data里
                        var Storage = window.sessionStorage; 
                        Storage.setItem('user', id)
                        this.$cookieStore.setCookie('user',id)
                        this.$router.push("/user_infor");//登录成功后跳转页面
                        return true;
                    }else if(res.code == -1){
                        this.tishi = "该手机号码不存在"
                        this.showTishi = true
                    }else if(res.code == 400){
                        this.tishi = "手机号码或密码错误"
                        this.showTishi = true
                    }
                })
            }
        },
        register(){
            if(this.newUsername == "" || this.newPassword == ""){
                alert("请输入手机号码或密码")
            }else{
                var params = {};
                params.code = this.code,
                params.unicode = this.wyz,
                params.tshare = this.share,
                params.username =  this.newUsername,
                params.nickname = this.nickname;
                params.password = this.$getCode(this.newPassword);
                params.quhao = this.gj.replace(/[^0-9]/gi, "");
                
                this.$api.getLogin.getUserResgiter(params).then((res)=>{
                    if (res.code == 200) {
                        this.tishi = "注册成功"
                        this.showTishi = true
                        this.newUsername = ''
                        this.newPassword = ''
                        /*注册成功之后再跳回登录页*/
                        setTimeout(function(){
                            this.showRegister = false
                            this.showLogin = true
                            this.forgetPassword = false
                            this.showTishi = false
                        }.bind(this),1000)
                    }
                })
            }
        },
        forgetPasswordReset(){
            if(this.newUsername == ""){
                alert("请输入手机号码或密码")
            }else{
                var params = {};
                params.code = this.code,
                params.unicode = this.wyz,
                params.username =  this.newUsername,
                params.password = this.$getCode(this.newPassword);
                params.quhao = this.gj.replace(/[^0-9]/gi, "");
                
                this.$api.getLogin.changePssword(params).then((res)=>{
                    if (res.code == 200) {
                        this.tishi = "修改成功"
                        this.showTishi = true
                        this.newUsername = ''
                        this.newPassword = ''
                        /*注册成功之后再跳回登录页*/
                        setTimeout(function(){
                            this.showRegister = false
                            this.showLogin = true
                            this.forgetPassword = false
                            this.showTishi = false
                        }.bind(this),1000)
                    }
                })
            }
        },
        getCODE () {
            var value = this.newUsername;
            let reg = /^1[3|4|5|7|8][0-9]{9}$/; 
            if (!reg.test(value) || value === ""){
                alert("请输入正确的手机号码")
            }else{
                this.sendcode();
            }
        },
        getForgetPasswordCODE () {
            var value = this.newUsername;
            let reg = /^1[3|4|5|7|8][0-9]{9}$/; 
            if (!reg.test(value) || value === ""){
                alert("请输入正确的手机号码")
            }else{
                this.sendResetPasswordCode();
            }
        },
        sendcode () {
            var value = this.newUsername;
            if (value === "") {
                alert("手机号码不能为空")
                this.$toast.fail("手机号码不能为空");
                return false;
            }
            this.$api.getLogin.is_have_user({
                username: value,
            }).then((res) => {
                if (res.status == 0) {
                    alert("用户已存在")
                    this.$toast.fail("用户已存在");
                    return false;
                } else {
                    this.sendduan();
                }
            });
        },
        sendResetPasswordCode() {
            var value = this.newUsername;
            if (value == "") {
                this.$toast.fail("手机号码不能为空");
                return false;
            }
            this.$api.getLogin.is_have_user({ username: value }).then(res => {
                if (res.status == 1) {
                    this.$toast.fail("用户未注册");
                    return false;
                } else {
                    this.sendfgpduan();
                }
            });
        },
        sendduan () {
            var _this = this;
            this.$api.getLogin.sendCode({
                tel: this.newUsername,
                quhao: this.quhao,
            }).then((res) => {
                // 验证码倒计时
                if (!this.timer) {
                    this.count = 60;
                    this.show = false;
                    this.wyz = res.result;
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= 60) {
                            this.count--;
                        } else {
                            this.show = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000);
                }
            });
        },
        sendfgpduan() {
            this.$api.getLogin.sendCode({
                tel: this.newUsername,
                quhao: this.quhao,
            }).then((res) => {
                // 验证码倒计时
                if (!this.timer) {
                    this.count = 60;
                    this.show = false;
                    this.wyz = res.result;
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= 60) {
                            this.count--;
                        } else {
                            this.show = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000);
                }
            });
        },
    }
}
</script>

<style scoped>
.lg_box{border:1px solid #f1f1f1;position:relative;padding:0 0 0 500px;/*height:490px;*/overflow:hidden;box-shadow:0px 3px 10px #f1f1f1;background-color:#fff;margin: 70px 0 120px 0;}
.lf_bg{position:absolute;left:0;top:0;}
.lh1{font-size:35px;color:#000;line-height:45px;margin:40px 40px 0 0;}
.logx{padding:20px 0 0 0;width:400px;}
.llabel{line-height:60px;height:60px;position:relative;border:1px solid #f0f0f0;padding:0 0 0 75px;border-radius:4px;margin-bottom:10px;overflow:hidden;}
.ll_left{position:absolute;left:15px;top:0;line-height:60px;font-size:16px;color:#333;}
.llpt{width:100%;height:60px;border:0;color:#000;font-size:16px;line-height:60px;vertical-align:top;}
.dxm{position:absolute;color:#6b73f7;right:0;top:0;border:0;background-color:#fff;height:60px;border-left:1px solid #f0f0f0;width:130px;text-align:center;cursor:pointer;}
.log_btn{background-color:#4c62fc;color:#fff;line-height:60px;border-radius:8px;text-align:center;font-size:18px;margin:40px 0 30px 0;border:none;box-shadow:0px 1px 8px #7a89f2;cursor:pointer;}
.fuwu{text-align:center;font-size:12px;color:#ccc;line-height:60px;width:60%;}
.U{color:#ccc;padding:0 4px;}
.ck_a{color:#999;line-height:34px;display:inline-block;margin:0 5px;border:1px solid #f1f1f1;border-radius:20px;padding:0 14px;*display:inline;zoom:1;}
.lgxx{text-align:center;line-height:30px;margin:90px 0 0 20px;width:60%;}
.f0{font-size:0px;text-align:center;}
.lg_btn{background-color:#e0e1e3;border-radius:8px;line-height:50px;text-align:center;width:40%;color:#888;display:inline-block;margin:0 10px;font-size:14px;}
.lg_btnr{background-color:#4c62fc;color:#fff;}
.fb_d{border-color:#fff;}
.lf_rm,.lf_rmb{position:absolute;right:0;top:0;z-index:1;}
.lf_rmb{z-index:2;}
p{color:red;}
</style>


// WEBPACK FOOTER //
// src/components/login/Index.vue